<template>
  <v-main>
    <v-container flex-column fill-height>
      <v-layout align-center justify-center>
        <v-flex class="reset-password-form">
          <v-card outlined>
            <p v-if="done" class="text-muted">
              Your password has been reset. You can now sign back into your
              account.
            </p>

            <v-form v-else>
              <validation-observer
                tag="form"
                ref="resetpassword"
                class="reset-password--form"
                @submit.prevent="onSubmit()"
              >
                <div class="reset-password-form__header">
                  <div class="reset-password-form__header-logo">
                    <img src="/img/brand/apio-symbol.svg" width="52px" />
                    <div>apio</div>
                  </div>
                  <div class="reset-password-form__reset-text">
                    <h1>Reset your password</h1>
                  </div>
                </div>
                <validation-provider
                  v-slot="{ }"
                  rules="required|min:8"
                  name="new_pass"
                  tag="div"
                >
                  <v-text-field
                    persistent-hint
                    type="password"
                    :error="true"
                    dense
                    outlined
                    label="New password"
                    hint="New password"
                    required
                    v-model="new_pass"
                    placeholder="Type here..."
                    :hide-details="true"
                  >
                  </v-text-field>
                </validation-provider>
                <password
                  v-model="new_pass"
                  @score="score"
                  :strength-meter-only="true"
                />

                <div class="tiny reset-password-form__weak-strong"><div>Weak</div><div>Strong</div></div>

                <p class="tiny mb-8">
                  Minimum 8 characters. Must include lowercase, upper case and a
                  number.
                </p>

                <v-text-field
                  class="mb-12"
                  persistent-hint
                  :error="true"
                  type="password"
                  dense
                  outlined
                  label="Confirm password"
                  hint="Confirm password"
                  required
                  v-model="new_pass_confirm"
                  placeholder="Type here..."
                  :hide-details="true"
                >
                </v-text-field>

                <p class="text-danger" v-if="message">{{ message }}</p>

                <apio-button
                  :disabled="
                    pwscore < 3 ||
                    new_pass == '' ||
                    new_pass_confirm == '' ||
                    new_pass != new_pass_confirm
                  "
                  variant="success"
                  block
                  @click="resetPassword()"
                  >Confirm</apio-button
                >
              </validation-observer>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import request from '@/API/';

export default {
  name: "PasswordResetForm",
  components: {
    Password: () => import("vue-password-strength-meter"),
    ApioButton: () => import("@/components/Misc/Button.vue"),
  },
  data() {
    return {
      new_pass: "",
      new_pass_confirm: "",
      message: "",
      errpwd: false,
      done: false,
      pwscore: 0,
    };
  },
  methods: {
    score(s) {
      this.pwscore = s;
    },
    resetPassword() {
      this.errpwd = false;
      if (
        this.pwscore < 3 ||
        this.new_pass == "" ||
        this.new_pass_confirm == "" ||
        this.new_pass != this.new_pass_confirm
      ) {
        this.errpwd = true;
        return;
      }
      request
        .post("/user/reset", {
          password: this.new_pass,
          hash: this.$route.params.hash,
        })
        .then((resp) => {
          if (resp.body.error != "" && resp.body.error != undefined) {
            this.message = resp.body.error;
            return;
          }
          this.done = true;
        })
        .catch((err) => {
          console.log(err);
          if (err.bodyText != "") {
            this.message = err.bodyText;
          } else {
            this.message = err.statusText;
          }
        });
    },
    validEmail: function (email) {
      var re = /^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style scoped lang="scss">
.Password {
  max-width: 760px;
}

apio-button {
  text-transform: none !important;
}

::v-deep .v-card__actions {
  flex-direction: column;
}

.theme--light.v-application {
  background: transparent;
}

.form-field-error {
  display: flex;
  visibility: visible;
}

.h3 {
  font-weight: normal;
  color: var(--apio-shade-2);
  margin-bottom: 40px;
}

.h1 {
  color: var(--apio-shade-2);
  margin-bottom: 8px;
}

.container {
  padding: 0;
}

.v-messages {
  position: absolute !important;
  top: -16px;
}

.v-input__prepend-inner {
  height: 16px !important;
}

.v-sheet--outlined {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-sheet.v-card {
  border-radius: 0;
  height: 576px;

  @media only screen and (max-width: 763px) {
    height: 100%;
    padding: 40px 20px;
    width: 100%;
  }
}

.apio-button {
  width: 100%;
}

.reset-password-form {
  margin: 40px 20px 40px 20px;
  width: 768px;
  height: 576px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  &__weak-strong {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  &__header {
    display: flex;
    width: 660px;
    margin-bottom: 32px;

    &-logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 24px;
      font-size: 30px;
      font-weight: bold;
    }
  }

  &__reset-text {
    display: flex;
    align-items: flex-end;
  }
}

@media screen and (max-width: 767px) {
  .reset-password-form {
    width: 330px;

    &__header {
      display: flex;
      flex-direction: column;
      width: 280px;
      margin-bottom: 32px;

      &-logo {
        display: flex;
        flex-direction: column;
        align-items: flex-center;
        width: 64px;
        margin-right: 24px;
        font-size: 30px;
        font-weight: bold;
      }
    }

    &__reset-text {
      display: flex;
      align-items: flex-end;
    }
  }
}
</style>
